import cropr, { GeometryModel } from "../utils/cropr";
import { Cropr } from "../utils/legacy";
import React from "react";

interface GeometryImageProps {
  model: GeometryModel;
  class?: string;
  size?: number;
  dimensions?: boolean;
  titleCenter?: boolean;
  children: string | React.ReactNode;
}

function GeometryImage({ children, model, ...options }: GeometryImageProps) {
  const { size = 75, dimensions = true } = options;
  const drawOptions = model.getDrawOptions(options);
  const geometry = model.getGeometry();
  const props = dimensions ? { height: size, width: size } : {};

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      {...props}
      viewBox={`0 0 ${size} ${size}`}
      className={options["class"] || ""}
    >
      <path
        d={Cropr.getSVGPath(geometry, size, size * 0.8)}
        fill={drawOptions.fillColor}
        stroke={drawOptions.strokeColor}
        strokeWidth="2"
        fillRule="evenodd"
      >
        <title>{model.get("name")}</title>
      </path>
      {children && (
        <text x={size / 2} y={size * (options.titleCenter ? 0.45 : 0.95)} textAnchor="middle">
          {children}
        </text>
      )}
    </svg>
  );
}

interface GeometryModelPreviewProps {
  model: GeometryModel;
  size?: number;
  titleCenter?: boolean;
  children?: React.ReactNode | string;
}

function GeometryModelPreview({
  model,
  size = 160,
  titleCenter = true,
  children,
}: GeometryModelPreviewProps) {
  if (!model.getGeometry()) return null;
  return (
    <div className="field-drawing overflow-auto text-center" style={{ height: `${size}px` }}>
      <GeometryImage model={model} titleCenter={titleCenter} size={size}>
        {children || cropr.toLocaleFixed(Cropr.getAreaString(model.getCalculatedArea()), 4)}
      </GeometryImage>
    </div>
  );
}
export default GeometryModelPreview;
